import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './recipes.component.html',
  styleUrls: ['./recipes.component.scss']
})
export class RecipesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log('RECIPES HAVE ARRIVED...');
  }

}
